import CatalogProdCard from "@/components/catalog/CatalogProdCard"

const ProductList = ({data}) => {
    return (
        <ul className='news-details__catalog-products'>
            {data.products_id?.map(product => (
                <CatalogProdCard
                    linked={true}
                    item={product}
                />
            ))}
        </ul>
    )
}

export default ProductList
